module.exports = __webpack_public_path__ + "img/EliHandel.4c7304bb.png";